<template>
  <div id="app">
    <Header/>
    <div id = "container">
      <router-view/>
    </div>
    <Footer/>
  </div>
</template>



<script>
import Header from './components/Header'
import Footer from './components/Footer'

export default {
  name: 'App',
  components : {
    Header,
    Footer
  }
}
</script>

<!-- Global site tag (gtag.js) - Google Analytics -->

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  /*font-family: 'IROHAMARU';*/
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  font-size: 12px;
  color: #262644;
  background: #e8ecff;

}

a:link { color: #551a8b; }

#container {
  width: 100%;
  max-width: 600px;
  mini-width: 100px;
  margin: 0 auto;
  min-height: 80vh;
}

.mb2{
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue